export default {
  title: {
    index: '我的推荐',
    potential: '潜在候选人',
    applied: '申请',
    hidden: '已隐藏'
  },
  menu: {
    index: '推荐',
    potential: '已推荐',
    applied: '已申请',
    hidden: '已隐藏'
  },
  label: {
    top: '置顶',
    myLeads: '推荐',
    switchActive: '隐藏',
    switchInactive: '显示',
    today: '今天',
    yesterday: '昨天'
  },
  message: {
    shareTip: '是你的朋友？点击再次分享职位给他们，鼓励他们申请或分享吧！',
    leadNoData: '目前还没有求职者，快去分享职位给Ta吧！',
    appliedNoData: '目前还没有求职者，快去分享职位给Ta吧！',
    optionSuccess: '操作成功'
  },
  btn: {
    moveAction: {
      removeTop: '取消置顶',
      pinTop: '置顶',
      hide: '隐藏',
      moveToPotential: '移至潜在'
    }
  },
  reward: {
    potential: '潜在'
  }
}
